import { SportMatchModel } from '@nf/types/odds'

import { StreamingControls } from '@/features/odds-page/streaming-controls';

/**
 * [Galaxy] Odds Page > Match Optoion
 * @description 此元件顯示於 width >= 1024 的清單式右側
 * @see MatchOption
 */
export const ListMatchOption = ({ 
	match 
}: {
	match: SportMatchModel;
}) => {
	return (
		<div className="match__option"/* match option component */>
			<StreamingControls 
				match={match}
				oddsPageLayout="list"
			/>
		</div>
	);
};